export default __webpack_public_path__ + "static/pragicts-digital-outreach-banner-industrial-61bfd3cb9a871ac37af8efc0103b721c.jpg";